<template>
    <div class="form-group">
        <label>{{ label }}</label>
        <input :type="type" :class="cssClass" v-model="input" @input="inputEvent" />
    </div>
</template>

<script>
export default {
    props: {
        value: null,
        css: { type: String, default: '' },
        label: { type: String, required: true },
        password: { type: Boolean, default: false }
    },
    data() {
        return {
            input: null
        }
    },
    computed: {
        type() {
            return this.password ? 'password' : 'text';
        },
        cssClass() {
            let css = ['form-control'];
            if(this.css) {
                css.push(this.css);
            }
            return css;
        }
    },
    methods: {
        inputEvent(event) {
            this.$emit('input', event.target.value);
        }
    },
    watch: {
        value: {
            immediate: true, 
            handler: function(newValue) {
                this.input = newValue;
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/primitives/TextField.vue